import axios from "axios";

const unwrap = (res) => res.data?.result ?? res.data;

export const gigaExplore = async (body) => unwrap(await axios.post("/api/giga/explore", body));

export const gigaInsights = async (body) => unwrap(await axios.post("/api/giga/insights", body));

export const gigaCampaigns = async (body) => unwrap(await axios.post("/api/giga/campaigns", body));

export const gigaListRuns = async ({ limit = 20, offset = 0 } = {}) =>
	unwrap(await axios.get("/api/giga/runs", { params: { limit, offset } }));

export const gigaListAdsAccounts = async () => unwrap(await axios.get("/api/giga/ads-accounts"));

export const gigaGetRun = async (id) => unwrap(await axios.get(`/api/giga/runs/${id}`));
